// extracted by mini-css-extract-plugin
export default {"empty":"Marathon_empty__83U1j"};